
import {
    Row, Col, Button, message, ImageFileId, AspectRatio
} from '../../ui/ot'
import React, { useEffect, useState, useRef } from "react"
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useBib } from '../../koha/controllers/bib_controller';
import { useSearchParams, useNavigate } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../ui/card"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/tabs"
import { BookOpen, StarIcon, Calendar, MapPin, Share2 } from "lucide-react"
import { Badge } from "../../ui/badge"
import ItemTable from './item_table'
import BiBInformation from './bibinfomation';
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "../../ui/carousel"

const CollectionSearchV2 = ({
    extraActionRender = () => { },
    keyPrefix = 'library.online_public_catalog_query_construction.collection_search',
    tabs = [


    ],
    star
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const biblionumber = searchParams.get("biblionumber")
    const [api, setApi] = useState()
    const [current, setCurrent] = useState(0)
    const [bookImageData, setBookImageData] = useState([])


    // 當輪播圖變化時更新當前索引
    const onSelect = () => {
        if (!api) return
        setCurrent(api.selectedScrollSnap())
    }

    // 設置輪播圖API並添加事件監聽器
    const setCarouselApi = (api) => {
        setApi(api)
        api.on("select", onSelect)
    }

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            message.success('網址已複製到剪貼簿！');
        } catch (err) {
            console.error('複製失敗', err);
            message.error('無法複製網址');
        }
    };

    const bibController = useCRUDController({
        apiRoute: "/koha/bib",
    })
    const {
        BibData,
        getBibData,
        getBibInfoFormat
    } = useBib({
        onFinish: () => { },
        onBefore: () => { }
    })
    useEffect(() => {
        getBibData({
            biblionumber: biblionumber,
            marcdata: "json"
        })

        bibController.getData({
            biblionumber: biblionumber
        }).then((response) => {
            let data = response?.data
            let firstData = data?.find(_ => true)
            let fileId = firstData?.bib_cover_images || []

            setBookImageData((pre) => {
                let file_id = fileId.map((val) => {
                    return {
                        file_id: val
                    }
                })
                if (file_id.length > 0) {
                    return [
                        ...file_id,
                    ]
                }
                else {
                    return [
                        {
                            src: "https://media.taaze.tw/showLargeImageByIsbn.ashx?isbn=" + firstData?.bibitem_isbn
                        },
                    ]
                }

            })
        })

    }, [])
    return (<Row gutter={[32, 32]}>
        <Col span={24}>
            {
                bibController.ResponseData?.map((value) => {
                    return (
                        <div className="container py-6 px-4 mx-auto">
                            <div className="md:grid md:grid-cols-3 gap-6">
                                <div className="md:col-span-1">
                                    <Card className="border-none shadow-lg">
                                        <div className="bg-gradient-to-b from-[#d5e6ed] to-[#eaf2f6] pt-8 pb-4 px-4">
                                            <div className="flex justify-center">
                                                <div className="relative">
                                                    <div
                                                        style={{
                                                            width: '280px'
                                                        }}
                                                    >
                                                    </div>
                                                    <div className="w-full max-w-4xl mx-auto px-1">
                                                        <Carousel
                                                            setApi={setCarouselApi}
                                                            className="w-full"
                                                            opts={{
                                                                align: "start",
                                                                loop: true,
                                                            }}
                                                        >
                                                            <CarouselContent>
                                                                {bookImageData.map((book, index) => (
                                                                    <CarouselItem key={book.id} >
                                                                        <AspectRatio ratio={3 / 4} className="bg-muted">
                                                                            {
                                                                                book?.file_id ?
                                                                                    <ImageFileId
                                                                                        file_id={book?.file_id}
                                                                                        className="w-full rounded-md object-cover"
                                                                                        width={280}

                                                                                    />
                                                                                    :
                                                                                    <ImageFileId
                                                                                        src={book?.src}
                                                                                        // file_id={book?.file_id}
                                                                                        className="w-full rounded-md object-cover"
                                                                                        width={280}

                                                                                    />
                                                                            }

                                                                        </AspectRatio>
                                                                    </CarouselItem>
                                                                ))}
                                                            </CarouselContent>
                                                            <div className="flex items-center justify-center gap-2 mt-4">
                                                                <CarouselPrevious className="static transform-none" />
                                                                <div className="text-sm">
                                                                    {current + 1} / {bookImageData.length}
                                                                </div>
                                                                <CarouselNext className="static transform-none" />
                                                            </div>
                                                        </Carousel>
                                                    </div>
                                                    {star && <div className="absolute -top-3 -right-3 bg-orange-500 text-white rounded-full p-2 shadow-md">
                                                        <div className="flex items-center gap-1">
                                                            {React.cloneElement(star, { biblionumber: biblionumber })}
                                                        </div>
                                                    </div>}
                                                </div>
                                            </div>
                                        </div>
                                        <CardContent className="bg-gradient-to-b from-[#eaf2f6] to-white pt-4">
                                            <div className="space-y-4">
                                                {/* <Button block={true} variant="outline" className="w-full border-[#2f7c9d] text-[#2f7c9d] hover:bg-[#eaf2f6]">
                                                    <Heart className="mr-2 h-4 w-4" /> 加入收藏
                                                </Button> */}
                                                <Button
                                                    onClick={() => {
                                                        handleCopy()
                                                    }}
                                                    block={true} variant="outline" className="w-full border-orange-300 text-orange-600 hover:bg-orange-50">
                                                    <Share2 className="mr-2 h-4 w-4" /> {t('share')}
                                                </Button>
                                            </div>

                                            <div className="mt-6 p-4 bg-[#eaf2f6] rounded-lg border border-[#d5e6ed]">
                                                <h3 className="font-medium text-[#2f7c9d] flex items-center gap-2 mb-2">
                                                    <Calendar className="h-4 w-4" /> {t('borrowing_info')}
                                                </h3>
                                                <p className="text-sm text-[#2f7c9d]">
                                                    {t('loan_period')}: <span className="font-semibold">30天</span>
                                                </p>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </div>

                                <div className="md:col-span-2">
                                    <Card className="border-none shadow-lg">
                                        <CardHeader className="bg-[#2f7c9d] text-white">
                                            <div className="flex flex-col space-y-2">
                                                <Badge className="w-fit bg-white text-[#2f7c9d] hover:bg-[#eaf2f6]">{value?.bib_materialType}</Badge>
                                                <CardTitle className="text-2xl font-bold">
                                                    {value?.bib_title}
                                                </CardTitle>
                                                <CardDescription className="text-[#d5e6ed] opacity-90">
                                                    {t('author')}: {value?.bib_author} |  {t('publication_date')}: {value?.bib_datecreated}
                                                </CardDescription>
                                            </div>
                                        </CardHeader>
                                        <CardContent className="pt-6">
                                            <Tabs defaultValue="details">
                                                <TabsList className="grid w-full grid-cols-3 bg-[#eaf2f6]">
                                                    {[
                                                        {
                                                            icon: <BookOpen className="mr-2 h-4 w-4" />,
                                                            tab: t('bibliographic_info'),
                                                            key: "details",
                                                            tabContent: <BiBInformation />
                                                        },
                                                        {
                                                            icon: <MapPin className="mr-2 h-4 w-4" />,
                                                            tab: t('holding_info'),
                                                            key: "holdings",
                                                            tabContent: <ItemTable
                                                                extraActionRender={extraActionRender}
                                                            />
                                                        },
                                                        ...tabs
                                                    ].map((val) => {
                                                        return (
                                                            <TabsTrigger
                                                                value={val?.key}
                                                                className="data-[state=active]:bg-[#2f7c9d] data-[state=active]:text-white"
                                                            >
                                                                {val?.icon}
                                                                {val?.tab}
                                                            </TabsTrigger>

                                                        )
                                                    })}
                                                </TabsList>
                                                {[
                                                    {
                                                        icon: <BookOpen className="mr-2 h-4 w-4" />,
                                                        tab: t('bibliographic_info'),
                                                        key: "details",
                                                        tabContent: <BiBInformation />
                                                    },
                                                    {
                                                        icon: <MapPin className="mr-2 h-4 w-4" />,
                                                        tab: t('holding_info'),
                                                        key: "holdings",
                                                        tabContent: <ItemTable
                                                            extraActionRender={extraActionRender}
                                                        />
                                                    },
                                                    ...tabs
                                                ]?.map((val) => {
                                                    const cloned = React.cloneElement(val?.tabContent, { bibValue: value });
                                                    return (
                                                        <TabsContent style={{ width: '100%' }} value={val?.key} className="space-y-4 mt-4">
                                                            {cloned}
                                                        </TabsContent>
                                                    )
                                                })}
                                            </Tabs>
                                        </CardContent>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    )
                })
            }

        </Col>
    </Row>)
}
export default CollectionSearchV2